































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { SchoolGroupCompetencyRankingStudent } from '@/models/school-group/school-group-competency-ranking';
import GCompetencyHeader from '@/components/GCompetencyHeader.vue';

@Component({
  name: 'GClassManagementCompetencyALLRankCard',
  components: { GCompetencyHeader },
  computed: {},
  methods: {},
})
export default class GClassManagementCompetencyALLRankCard extends mixins(GPageBase) {
  @Prop() competencyRanking: SchoolGroupCompetencyRankingStudent[];
  MAX_ROW_COUNT: number = 20;

  mounted() {}

  getIndex(col: number, row: number): number {
    return (col - 1) * this.MAX_ROW_COUNT + row - 1;
  }

  get rankingLength(): number {
    return this.competencyRanking && this.competencyRanking ? this.competencyRanking.length : 0;
  }

  get rankingSurplusCount(): number {
    let count = this.rankingLength % this.MAX_ROW_COUNT;
    return count === 0 ? this.MAX_ROW_COUNT : count;
  }

  get rankingColumnCount(): number {
    return Math.ceil(this.rankingLength / this.MAX_ROW_COUNT);
  }

  getGradeAndSchoolClassNameFullName(index: number): string {
    return `${this.competencyRanking[index].gradeAndSchoolClassName} ${this.competencyRanking[index].studentName}`;
  }

  getLinkToKarte(index: number): string {
    const url = this.$router.resolve({
      name: 'student-record',
      params: { studentID: this.competencyRanking[index].studentID.toString() }
    }).href
    return url;
  }
}
